import { EventBus } from '@/services/eventbus'
export default {
  data () {
    return {
      timeoutId: null
    }
  },
  methods: {
    parseErrorMessage: function (object) {
      if (typeof object.details !== 'undefined') {
        const message = Object.values(object.details)
        if (message.length) {
          object.message = ''
          object.message += '<br/>'
          object.message += message.join('<br/>')
        }
      }

      return object.message
    },
    setSidebarValues (type, value) {
      this.$store.dispatch('setSidebarValues', {
        type: type,
        value: value
      })
    },
    selectFolder (folder = null) {
      if (folder) {
        this.$store.dispatch('setRootPath', folder.path)
        this.$store.dispatch('setAssetQuery', {
          path: folder.path
        }).then(() => {
          EventBus.$emit('reset-category', true)
          EventBus.$emit('navigation-open', false)
        })
      }
    },
    setExpandedFilter (filter) {
      let index = this.$store.state.expandedFilter.indexOf(filter)
      if (index === -1) {
        this.$store.dispatch('addExpandedFilter', filter)
      } else {
        this.$store.dispatch('removeExpandedFilter', index)
      }
    },
    setCategory (cat) {
      this.setSidebarValues('activeCategory', cat)
      this.setSidebarValues('activeFilter', [])
      this.setSidebarValues('expandedFilter', [])
      this.$store.dispatch('addActiveFilter', {
        field: 'Category',
        value: [cat]
      })
      this.setSidebarValues('checkedValues', [])
      this.$store.dispatch('setAssetQuery', {
        filter: this.$store.state.activeFilter
      })
    },
    resetCategory () {
      this.setSidebarValues('activeCategory', null)
      this.setSidebarValues('lastActiveFilter', {
        field: null,
        values: []
      })
      this.setSidebarValues('activeFilter', [])
      this.setSidebarValues('expandedFilter', [])
      this.setSidebarValues('checkedValues', [])
      this.$store.dispatch('setAssetQuery', {
        filter: this.$store.state.activeFilter
      })
    },
    setFilter (key, value, values, debounceDuration = false) {
      this.setSidebarValues('lastActiveFilter', {
        field: key,
        values: values
      })

      if (!this.$store.state.activeFilter.length || !this.$store.state.activeFilter.find(function (filter) { return filter.field === key })) {
        this.$store.dispatch('addActiveFilter', {
          field: key,
          value: []
        })
      }

      let active = this.$store.state.activeFilter.find(function (filter) { return filter.field === key })

      let index = active.value.indexOf(value)
      if (index > -1) {
        active.value.splice(index, 1)

        if (!active.value.length) {
          this.setSidebarValues('activeFilter', this.$store.state.activeFilter.filter(function (el) { return el.field !== active.field }))
        }
      } else {
        active.value.push(value)
      }

      if (debounceDuration) {
        let scope = this
        if (this.timeoutId !== null) {
          clearTimeout(this.timeoutId)
        }
        this.timeoutId = setTimeout(_ => {
          scope.timeoutId = null
          this.$store.dispatch('setAssetQuery', {
            filter: scope.$store.state.activeFilter
          })
        }, debounceDuration)

        return
      }

      this.$store.dispatch('setAssetQuery', {
        filter: this.$store.state.activeFilter
      })
    }
  }
}
